import { createFileRoute } from '@tanstack/react-router';
import { IndicatorsPage } from '@/features/foodcost/IndicatorsPage';

export const Route = createFileRoute('/_app/foodcost/indicatori')({ component: IndicatorsPage });
